import client from "./clients/portalClient";

const getAllRates = () => client.get(`/rates`);
const postNewRates = (data) => client.post(`/rates`, data);

const adminRatesApi = {
    getAllRates,
    postNewRates,
};

export default adminRatesApi;
